export enum StorageEntityName {
  access_token = 'access_token',
  tokenExpiration = 'tokenExpiration',
  promoter = 'promoter',
  customers = 'customers',
  routes = 'routes',
  evaluations = 'EVALUATIONS',
  instruments = 'INSTRUMENTS',
  evaluations2 = 'EVALUATIONS_2',
  evaluationsIndex = 'EVALUATION_INDEX',
  products = 'PRODUCTS',
  subCategories = 'SUB-CATEGORIES',
  evidenceTypes = 'EVIDENCE_TYPES',
  exhibitions = 'EXHIBITIONS',
  companyBlocks = 'COMPANY_BLOCKS',
  updatePostponedAt = 'updatePostponedAt',
  pendingPhotoCapture = 'PENDING_PHOTO_CAPTURE',
  activeNavigation = 'ACTIVE_NAVIGATION',
}
